import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ConfigService } from "../../configurations/services/config.service";

@Injectable({
  providedIn: "root",
})
export class ManageStaffService {
  httpOptions;
  headerObj: any;

  constructor(private http: HttpClient, private configService: ConfigService) {}

  getPermissions() {
    return this.http.get<any>(
      environment.configUrl +
        "Permission/GetAllPermission?CurrentDate=" +
        new Date()
    );
  }

  InsertStaffDetails(data) {
    return this.http.post<any>(
      environment.configUrl +
        "Staff/AddStaffFromAdminPanel?CurrentDate=" +
        new Date(),
      data
    );
  }

  GetAllStaffByPublish(StaffID, Publish, ArchiveFlag) {
    return this.http.get<any>(
      environment.configUrl +
        "Staff/GetAllStaffByPublish?StaffID=" +
        this.configService.enc(StaffID.toString()) +
        "&Publish=" +
        this.configService.enc(Publish.toString()) +
        "&ArchiveFlag=" +
        this.configService.enc(ArchiveFlag.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  getRoles(RoleID) {
    return this.http.get<any>(
      environment.configUrl +
        "RolesPermissions/GetAllRoles?RoleID=" +
        RoleID +
        "&CurrentDate=" +
        new Date()
    );
  }

  getRotaPermitedList() {
    return this.http.get<any>(
      environment.configUrl +
        "Permission/GetRotaPermitedList?CurrentDate=" +
        new Date()
    );
  }

  // getStaffList(StaffID) {
  //   return this.http.get<any>(
  //     environment.configUrl +
  //       "Staff/GetAllStaff?StaffID=" +
  //        this.configService.enc(StaffID.toString()) +
  //       "&CurrentDate=" +
  //       new Date()
  //   );
  // }
  GetRolePermissions(selectedRoles) {
    return this.http.get<any>(
      environment.configUrl +
        "Permission/GetPermissionForRole?RoleData=" +
        selectedRoles +
        "&CurrentDate=" +
        new Date()
    );
  }

  InsertRolePermissions(data) {
    return this.http.post<any>(
      environment.configUrl +
        "Permission/InsertRolePermission?CurrentDate=" +
        new Date(),
      data
    );
  }


  InsertRotaPermissions(data) {
    return this.http.post<any>(
      environment.configUrl +
        "Permission/InsertRotaPermissions?CurrentDate=" +
        new Date(),
      data
    );
  }


  InsertOrUpdateRoles(formData) {
    return this.http.post<any>(
      environment.configUrl +
        "Staff/InsertOrUpdateRoles?CurrentDate=" +
        new Date(),
      formData
    );
  }

  DeleteRolesByRoleID(roleID) {
    return this.http.get<any>(
      environment.configUrl +
        "Staff/DeleteRolesByRoleID?RoleID=" +
        roleID +
        "&CurrentDate=" +
        new Date()
    );
  }

  setRolePermissions(permissionsData) {
    localStorage.setItem(
      "REFRESHDATA",
      this.configService.enc(JSON.stringify(permissionsData))
    );
  }

  getStoredStaffRolePermissions(permissionText) {
    const permission = this.userPermissions().find((data) => {
      return data.Permission === permissionText;
    });
    return permission ? true : false;
  }

  userPermissions() {
    const permissions = JSON.parse(
      this.configService.dec(localStorage.getItem("REFRESHDATA"))
    );
    return permissions ? permissions : [];
  }

  ForgotPassword(StaffID, NewPassword) {
    return this.http.get(
      environment.configUrl +
        "Staff/UpdateStaffPassword?StaffID=" +
        this.configService.enc(StaffID.toString()) +
        "&NewPassword=" +
        this.configService.enc(NewPassword.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetPermissionForStaffID(StaffID) {
    return this.http.get<any>(
      environment.configUrl +
        "Permission/GetPermissionForStaffID?StaffID=" +
        this.configService.enc(StaffID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdateArchivedFlagByStaffID(StaffID, ArchiveFlag) {
    return this.http.get<any>(
      environment.configUrl +
        "Staff/UpdateArchivedFlagByStaffID?StaffID=" +
        this.configService.enc(StaffID.toString()) +
        "&ArchiveFlag=" +
        ArchiveFlag +
        "&CurrentDate=" +
        new Date()
    );
  }

  AssignSortOrderForStaff(SortData) {
    return this.http.post<any>(
      environment.configUrl +
        "Staff/AssignSortOrderForStaff?CurrentDate=" +
        new Date(),
      SortData
    );
  }

  InsertOrUpdateStaffProfilePicture(StaffID, ImageData) {
    this.headerObj = new HttpHeaders({
      ContentType: null,
      Accept: "multipart/form-data",
    });
    this.httpOptions = {
      headers: this.headerObj,
    };
    return this.http.post(
      environment.configUrl +
        "Staff/InsertOrUpdateStaffProfilePicture?StaffID=" +
        this.configService.enc(StaffID.toString()) +
        "&CurrentDate=" +
        new Date(),
      ImageData
    );
  }
}
